import styled from "styled-components";
import { Grid } from "@mui/material";
import { theme } from "styles/mui-config";
import Slider from "react-slick";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

export const StyledImgdiv = styled.div`
  border-radius: 4px;
  width: 225px !important;
  height: 225px !important;
  margin: auto;
  max-width: 100%;
`;

export const StyledColorsProduct = styled.div`
  width: 100px;
  height: 19px;
  overflow: hidden;
  margin: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content:center;
  & > span{
    display:inline-block;
    width:10px;
    height:10px;
    border-radius:100%;
    border 1px solid gray;
    margin:5px;
  }
`;

export const StyledSlideProductDiv = styled.div`
  background-color: #fff;
  color: rgba(0, 0, 0, 0.87);
  border-radius: 4px;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 1px -1px,
    rgba(0, 0, 0, 0.14) 0px 1px 1px 0px, rgba(0, 0, 0, 0.12) 0px 1px 3px 0px;
  width: 100%;
  padding: 10px;
  position: relative;
  & img {
    border-radius: 4px;
  }
  & h2 {
    font-size: 15px;
    font-weight: 300;
    line-height: 2.17;
    color: #41464f;
    height: 52px;
    overflow: hidden;
    text-align: right;
    direction: rtl;
    margin-top: 2px;
  }

  & p {
    margin: 0;
    text-align: left;
    color: #41464f;
    font-size: 17px;
    direction: rtl;
    & span:nth-child(2) {
      font-size: 12px;
    }
  }
  .product-p {
    text-decoration: line-through !important;
    color: #bdc0c4;
  }
`;

export const StyledSlideProductDiscount = styled.div`
  position: absolute;
  width: 42px;
  height: 25px;
  border-radius: 31px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  bottom: 10px;
  right: 10px;
  font-size: 14px;
  background-color: #f1394e !important;
`;

export const StyledMain = styled.div`
  // background: linear-gradient(
  //   transparent 50%,
  //   ${theme.palette.primary.dark} 50%
  // ) !important;
  margin-bottom: 60px;
  padding-right: 48px;
  padding-left: 48px;
`;

export const StyledSlider = styled(Slider)`
  .slick-slide {
    padding: 10px;
  }
  & svg {
    // top: 69% !important;
  }
`;

export const StyledImageSlider = styled(Slider)`
  .slick-slide {
    padding: 0px;
  }
  & svg {
    // top: 69% !important;
  }
`;

export const StyledMainTop = styled.div`
  // background: linear-gradient(
  //   transparent 50%,
  //   ${theme.palette.primary.dark} 50%
  // ) !important;
  margin-bottom: 20px;
  padding-right: 48px;
  padding-left: 48px;
`;

export const StyledTitle = styled.h2`
  text-align: center;
  font-size: 34px;
  font-family: "Avini";
  margin: 0;
  @media (max-width: 900px) {
    font-size: 27px;
  }
  color: ${theme.palette.primary.darkText};
  position: relative;
  margin-bottom: 27px;
  &::after {
    content: "";
    width: 54px;
    height: 4px;
    background: ${theme.palette.primary.dark};
    position: absolute;
    bottom: -12px;
    margin: auto;
    left: 50%;
    right: 50%;
    transform: translatex(-50%);
    border-radius: 46px;
  }
`;

export const StyledDiv = styled.div`
  // min-height: 100vh;
  // background: linear-gradient(
  //   190deg,
  //   #04c1f3 49.93%,
  //   #009ac2 85.84%
  // ) !important;
  background-color: ${theme.palette.primary.dark};
  background-size: cover;
  // position: relative;
  // top: -109px;
  z-index: -1;
  direction: rtl;
  padding-top: 30px;
  padding-bottom: 30px;
  padding-right: 30px;
  padding-left: 30px;
  display: flex;
  align-items: center;
  @media (max-width: 900px) {
    padding-bottom: 20px;
  }
`;
export const StyledGridTop = styled(Grid)`
  display: flex !important;
  flex-direction: column !important;
  justify-content: center !important;
  & ol {
    padding-right: 15px;
    list-style: circle;
  }
  & ol > li {
    color: white;
    font-size: 19px;
    padding-bottom: 11px;
  }
`;

export const StyledImg = styled.img`
  width: 90% !important;
  padding: 113px;
  padding-top: 40px;
  padding-bottom: 40px;
  @media (max-width: 1000px) {
    padding: 40px;
    padding-top: 20px;
    padding-bottom: 20px;
    width: 100% !important;
  }
`;

export const Styledh2 = styled.h2`
  color: white;
  font-size: 33px;
  font-family: "Avini";
  margin: 0;
  @media (max-width: 900px) {
    font-size: 27px;
  }
`;

export const StyledShowAlldiv = styled.div`
  width: 100%;
  & > button {
    margin-left: 10px;
  }
  & > button > a {
    width: 104px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: ${theme.palette.primary.dark};
  }
`;

export const StyledSliderAcc = styled(Slider)`
  .slick-slide {
    // padding: 10px;
  }

  & > .Nextarrow {
    position: absolute;
    bottom: 0px;
    right: 120px;
    z-index: 1;
    width: 40px;
    height: 40px;
    border-radius: 100%;
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.5s;
    transition-delay: 0.5s;
    opacity: 0;
    cursor: pointer;
    @media (max-width: 900px) {
      display: none;
    }
    & > svg {
      color: ${theme.palette.primary.dark} !important;
      left: 0;
      right: 0;
      position: static;
      transform: translate(0, 0);
      transform: rotate(180deg);
      font-size: 21px;
      margin-right: 3px;
    }
    &:hover {
      background: #f1f1f1;
      box-shadow: 0px 0px 6px 0px #cecece;
    }
  }
  &:hover .Nextarrow {
    opacity: 1;
    transition-delay: 0s;
    bottom: 30px;
  }
  & > .Prevarrow {
    position: absolute;
    bottom: 10px;
    right: 65px;
    z-index: 1;
    width: 40px;
    height: 40px;
    border-radius: 100%;
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.5s;
    transition-delay: 0.5s;
    opacity: 0;
    cursor: pointer;
    @media (max-width: 900px) {
      display: none;
    }
    & > svg {
      color: ${theme.palette.primary.dark} !important;
      left: 0;
      right: 0;
      position: static;
      transform: translate(0, 0);
      font-size: 21px;
      margin-left: 3px;
    }
    &:hover {
      background: #f1f1f1;
      box-shadow: 0px 0px 6px 0px #cecece;
    }
  }
  &:hover .Prevarrow {
    opacity: 1;
    transition-delay: 0s;
    bottom: 30px;
  }
`;

export const StyledTypographyContent = styled.p`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4; /* number of lines to show */
  -webkit-box-orient: vertical;
  color: rgba(0, 0, 0, 0.6);
  padding-top: 0;
  & > a {
    color: white;
  }
`;
